import { createContext, useContext } from 'react';

type AnalyticsContext = {
  identify: (id: string, traits?: Record<string, unknown>) => void;
  track: (event: string, properties?: Record<string, unknown>) => void;
};

export const AnalyticsContext = createContext<AnalyticsContext | null>(null);

export const useEventsContext = () => useContext(AnalyticsContext)!;
